<template>
  <div class="d-flex align-center justify-center flex-wrap py-6">
    <v-pagination
      v-if="totalPages > 1 && isShow"
      v-model="number"
      v-bind="$attrs"
      class="text-center mb-5 flex-md-grow-1 mr-md-n50"
      :length="totalPages"
      :page="number"
      total-visible="10"
      :disabled="disabled"
      color="red"
    />

    <v-sheet
      v-if="isShowSize && isShow"
      min-width="100"
      max-width="100"
      class="ml-auto mr-5 mb-5"
      color="transparent"
    >
      <CustomSelect
        :value="rowSize"
        :items="ROW_SIZES"
        hide-details
        :outlined="false"
        :disabled="disabled"
        solo
        :label="$t('label.rowsPage')"
        @change="$emit('size', $event)"
      />
    </v-sheet>
  </div>
</template>

<script>
import {ROW_SIZES} from '@/helpers/table'

export default {
  name: 'Pagination',
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isShowSize: {
      type: Boolean,
      default: true,
    },
    rowSize: {
      type: [String, Number],
      default: undefined,
    },
  },
  data: () => ({
    ROW_SIZES,
  }),
  computed: {
    number: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
